const DANGEROUS_SCHEME_RE = /^\s*(javascript|data|vbscript|file):/i

export const isValidURL = (url: string): boolean => {
  if (DANGEROUS_SCHEME_RE.test(url)) return false
  try {
    const normalized = url.includes('://') ? url : `https://${url}`
    const parsed = new URL(normalized)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
  } catch {
    return false
  }
}
